export default __webpack_public_path__ + "static/media/bdswissSCReal04_downloadMT4.c1ce1bf5.png";